import { render, staticRenderFns } from "./Hotness.vue?vue&type=template&id=f2659466&lang=pug"
import script from "./Hotness.vue?vue&type=script&lang=js"
export * from "./Hotness.vue?vue&type=script&lang=js"
import style0 from "./Hotness.vue?vue&type=style&index=0&id=f2659466&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports